import { isDate } from 'date-fns';
import { Chips, DatePicker, Separator, useTranslationContext } from 'platform/components';
import { HStack, VStack } from 'platform/foundation-tw';
import { intersection } from 'ramda';
import { getApiDateString, isApiDateString, parseDate, suffixTestId } from 'shared/web';
import { quickFiltersConst } from '../../constants/quickFilters';
import { useFilterOnChipsChange } from '../../hooks/useFilterOnChipsChange';
import type { EagFilterProps } from '../../types/EagFilterProps';
import { getFilterFieldName } from '../../utils/getFilterFieldName';
import { parseDateFilter } from '../../utils/parseDateFilter';
export type DateFilterProps = EagFilterProps & {
  min: string | null;
  max: string | null;
  relativeDates: Array<{
    value: string;
    label: string;
  }>;
  quickFilters?: Array<{
    value: string;
    label: string;
  }>;
};
const FILTER_VALUE_KEY = 'value';
export function DateFilter(props: DateFilterProps) {
  const t = useTranslationContext();
  const minDate = parseDateFilter(props.min);
  const maxDate = parseDateFilter(props.max);
  const model = props.value[FILTER_VALUE_KEY] as string | null ?? null;
  const setFilterValue = (filterModel: Date | string | null) => {
    const newModel = isDate(filterModel) ? getApiDateString(filterModel) : filterModel;
    props.onChange({
      [FILTER_VALUE_KEY]: newModel
    });
  };
  const {
    onChipsChange
  } = useFilterOnChipsChange({
    setFilterValue,
    defaultValue: null
  });
  const datePickerValue = isApiDateString(model) ? parseDate(model) : null;
  const chipsValue = typeof model === 'string' ? [model] : [];
  const isQuickFilterValue = intersection([model], quickFiltersConst) as string[];
  return <VStack spacing={4}>
      {props.quickFilters && props.quickFilters.length > 0 && <>
          <HStack>
            <Chips isDisabled={props.isDisabled} value={isQuickFilterValue} options={props.quickFilters} onChange={onChipsChange} isMultiple={false} data-testid={suffixTestId('date-filter-quickFilters', props)} isDeselectable />
          </HStack>
          <Separator spacing={0} />
        </>}
      {props.relativeDates && props.relativeDates.length > 0 && <Chips isDisabled={props.isDisabled} value={chipsValue} options={props.relativeDates} onChange={onChipsChange} data-testid={suffixTestId('date-filter-relativeDates', props)} isDeselectable />}
      <DatePicker isDisabled={props.isDisabled} placeholder={t('page.datagrid.filter.datePlaceholder', {
      field: getFilterFieldName(props.column)
    })} value={datePickerValue} onChange={setFilterValue} minDate={minDate} maxDate={maxDate} data-testid={suffixTestId('date-filter', props)} />
    </VStack>;
}